import { t } from 'i18next';
import * as yup from 'yup';

import { numberSchemaWithTransform } from 'core/yup';

export const upsertLogsSchema = () =>
  yup.object({
    user: yup.object().label(t('labelUser')).nullable().required(),
    task: yup.object().label(t('labelTask')).nullable().required(),
    note: yup.string().label(t('labelNote')).nullable(),
    timeLogs: yup
      .array()
      .of(
        yup.object({
          activityDate: yup.date().label(t('labelActivityDate')).required(),
          duration: numberSchemaWithTransform()
            .label(t('labelDurationHours'))
            .positive()
            .required(),
        })
      )
      .min(1, t('errorActivityTimeRequiredAtLeastOne'))
      .label(t('labelActivityTime'))
      .required(t('errorActivityTimeRequiredAtLeastOne')),
  });
